module.exports = __webpack_public_path__ + "static/media/firstfloor1.39a8f756.png";